import {useEffect, useState} from "react";
import "../assets/css/style.css"
import registerVector from '../assets/img/logo2.png'
import userIcon from '../assets/img/user.png'
import {Button, FormGroup, Input, Label} from "reactstrap";
import {Link, useSearchParams} from "react-router-dom";
import ReactInputVerificationCode, {
    ReactInputVerificationCodeProps,
} from 'react-input-verification-code';
import {toast} from "react-toastify";
import axios from "axios";
import {Dimmer, Loader} from "semantic-ui-react";
import Dropdown from "react-bootstrap/Dropdown";
import iran from "../assets/img/iran.png";
import english from "../assets/img/english.png";


const Register = () => {
    const [height, setHeight] = useState(window.innerHeight);
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [mobileInput, setMobileInput] = useState(false);
    const [emailInput, setEmailInput] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isDisable, setIsDisable] = useState(false);
    const [sellerId, setSellerId] = useState(null);
    const [searchParams] = useSearchParams();

    const handleResize = () => {
        setHeight(window.innerHeight);
    };
    const customProps: ReactInputVerificationCodeProps = {
        autoFocus: true,
        length: 4,

    };

    function checkPhone() {
        const iranianPhoneNumberRegex = /^(09)?\d{8}$/;
        if (phone == '') {
            setShowAlert('فیلد شماره همراه الزامی می باشد')
        }
        if (iranianPhoneNumberRegex.test(phone)) {
            setShowAlert(false)
        } else {
            setShowAlert(true)
            setAlertText('شماره همراه وارد شده معتبر نمی باشد.')
        }


    }

    function register(e) {
        e.preventDefault()
        const data = new FormData();
        data.append('mobile', phone)
        data.append('email', email)
        data.append('name', name)
        data.append('type', type)
        if (sellerId !== null){
            data.append('seller_id',sellerId)
        }
        axios.post('https://rahatsite.com/api/register', data)
            .then((res) => {
                setIsDisable(false)
                setIsLoading(true)
                if (res.data.success) {

                    toast.success('ثبت نام با موفقیت انجام شد', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                    if (res.data.data.token !== null) {
                        window.localStorage.setItem('token', res.data?.data?.token)
                        window.location.replace('/chat')
                    }


                } else {
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {
                if (type === 'mobile'){
                    setEmail('')
                }
                else {
                    setPhone('')
                }

                setName('')
                setIsDisable(false)
                setIsLoading(true)

                if (err.response.status === 422) {
                    let errors = [];
                    for (let error in err.response.data.errors)
                        err.response.data.errors[error].forEach((item) =>
                            errors.push(item)
                        );

                    errors.map((item, index) => {
                        toast.error(index + 1 + " - " + item, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });

                    })

                } else {
                    toast.error('خطا مجددا امتحان کنید', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }


            })
    }

    useEffect(() => {
        let id =searchParams.get('sellerId');
        if (id !== null){
            setSellerId(id)
        }
        if (!window.localStorage.getItem('type')) {
            window.location.replace('/')
        } else {
            setType(window.localStorage.getItem('type'));
            const mobile = window.localStorage.getItem('mobile');
            const mail = window.localStorage.getItem('email');
            if (window.localStorage.getItem('type') === 'mobile') {
                setPhone(mobile)
                setMobileInput(true)
            } else {
                setEmail(mail)
                setEmailInput(true)
            }
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            <div className="container-fluid register-back" style={{height: height + 'px'}}>
                <div className={'row justify-content-end'}>
                    <div className={"col-12 col-lg-4 register-box text-center"} style={{height: height + 'px'}}>
                        <h4 style={{fontWeight: 800, color: '#FFD02A',fontFamily:'IRANSans',fontSize:'20px'}}>به پنل گفتگوی مشتریان راحت بین خوش آمدید <span
                            style={{color: '#fff!important'}}>👋</span></h4>
                        <div className="row justify-content-center text-center mt-5">
                            <Dropdown>
                                <Dropdown.Toggle variant="warning"  align={{ lg: 'center' }} id="dropdown-basic" className={'px-5'}>
                                    زبان
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/register" style={{direction:'rtl',textAlign:'right'}}>
                                        <img src={iran} className={'ms-3'} width={30} height={20} alt=""/>فارسی
                                    </Dropdown.Item>
                                    <Dropdown.Item href="/register/en"  style={{direction:'rtl',textAlign:'right'}} >
                                        <img src={english} className={'ms-3'} width={30} height={20} alt=""/>English
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className={"row justify-content-center custom-styles"}>
                            <div className={'col-12 col-md-10 register-form justify-content-center text-center'}>
                                <img className={'user-icon'} src={userIcon} alt=""/>
                                <h3 style={{fontWeight: 800,fontFamily:'IRANSans',fontSize:'20px'}}>ثبت نام</h3>
                                <div className={'col-12 text-end send-email'} style={{fontFamily:'IRANSans'}}>

                                    <FormGroup>
                                        <Label for="name">نام و نام خانوادگی</Label>
                                        <Input type="text" name="name" id="name"  style={{fontFamily:'IRANSans'}} onChange={(e) => {
                                            setName(e.target.value)
                                        }} placeholder="نام خود را وارد کنید..."/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="phone">شماره همراه</Label>
                                        <Input type="text" name="phone" style={{fontFamily:'IRANSans'}}
                                               disabled={mobileInput} defaultValue={mobileInput ? phone : ''}
                                               id="phone" onChange={(e) => {
                                            setPhone(e.target.value)
                                            checkPhone()
                                        }} placeholder="شماره همراه خود را وارد کنید..."/>
                                    </FormGroup>
                                    {showAlert && <div
                                        className={'col-12 text-end alert alert-danger p-1'}>{alertText}</div>}
                                    <FormGroup>
                                        <Label for="exampleEmail">ایمیل</Label>
                                        <Input type="email" name="email" disabled={emailInput}  style={{fontFamily:'IRANSans',direction:'ltr'}}
                                               defaultValue={emailInput ? email : ''} id="exampleEmail"
                                               onChange={(e) => {
                                                   setEmail(e.target.value)
                                               }} placeholder="ایمیل خود را وارد کنید..."/>
                                    </FormGroup>
                                </div>
                                <div className={'col-12 text-center'}>

                                    <Button className={'custom-btn2'} size={'lg'} disabled={email === '' && type === 'email' || phone === '' && type === 'mobile' || name === '' || isDisable} onClick={(e) => {
                                        register(e)
                                        setIsDisable(true)
                                        setIsLoading(false)
                                    }} block>
                                        {!isLoading ?
                                            <Dimmer active>
                                                <Loader content='Loading' />
                                            </Dimmer> : 'ثبت نام'}
                                    </Button>
                                </div>
                            </div>

                            {/*<div className={'col-10 col-md-7 text-center mt-4 link-border'}>*/}
                            {/*    <Link to={'/login'}>Already have an account? Log in</Link>*/}
                            {/*</div>*/}

                        </div>
                    </div>
                    <div className={"col-md-0 col-lg-8 "}>
                        <div className={"row justify-content-center vector"}>
                            <div className={'col-6'}>
                                <img src={registerVector} width={600} height={'auto'} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Register;